import { createAction, props } from '@ngrx/store';

export const ImageCacheActions = {
  // Action to trigger when an image is uploaded/updated
  imageUpdated: createAction(
    '[Image Cache] Image Updated',
    props<{ imageUrl: string; newImageUrl?: string }>()
  ),
  
  // Action to clear specific image from cache
  clearImageCache: createAction(
    '[Image Cache] Clear Image Cache',
    props<{ imageUrl: string }>()
  ),
  
  // Action to clear all cached images
  clearAllImageCache: createAction('[Image Cache] Clear All Image Cache'),
  
  // Action for profile image updates specifically
  profileImageUpdated: createAction(
    '[Image Cache] Profile Image Updated',
    props<{ userId: string; oldImageUrl?: string; newImageUrl: string }>()
  )
};